import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
import pdfLogo from "../../assets/icons/pdf-logo.png";

const UploadedOtherDocumentCard = ({ image, filename, fileSize, fileType }) => {
	return (
		<Box sx={{ display: "flex", border: "1px solid #e2e8f0", mb: "1.5rem" }}>
			{image && (
				<Box sx={{ height: "8rem", width: "8rem", paddingRight: "1rem" }}>
					<img
						src={fileType === "application/pdf" ? pdfLogo : image}
						alt=""
						height="100%"
						width="100%"
						style={{ objectFit: "cover" }}
					/>
				</Box>
			)}
			<Box
				sx={{
					padding: "1rem",
					display: "flex",
					flexDirection: "column",
					width: "100%",
				}}
			>
				<Typography variant="body2" gutterBottom>
					{filename}
				</Typography>
				<Typography variant="body2" gutterBottom>
					{fileSize > 1000000
						? `${(fileSize / 1000000).toFixed(1)}mb`
						: `${Math.round(fileSize / 1000)}kb`}
				</Typography>
				{/* <Box sx={{ mt: "auto", display: "flex" }}>
					<Button variant="contained" color="error" sx={{ ml: "auto" }}>
						remove
					</Button>
				</Box> */}
			</Box>
		</Box>
	);
};

export default UploadedOtherDocumentCard;
